/**
 * Based on a ref determines if there is overflow and a tooltip should be shown
 *
 * In order for this to work properly and get the '...' to show up you need to use the following props:
 * whiteSpace="nowrap"
 * overflow="hidden"
 * textOverflow="ellipsis"
 * Note: using noOfLines={1} will not work for determining if there is overflow
 */

export const useHasTextOverflow = (el: HTMLDivElement | null) => {
  const textVisibleWidth = el?.offsetWidth ?? 0;
  const textContentWidth = el?.scrollWidth ?? 0;
  return textVisibleWidth < textContentWidth;
};
